import { render, staticRenderFns } from "./newsletterbottom_section.vue?vue&type=template&id=a1b058a8&scoped=true&"
import script from "./newsletterbottom_section.vue?vue&type=script&lang=js&"
export * from "./newsletterbottom_section.vue?vue&type=script&lang=js&"
import style0 from "./newsletterbottom_section.vue?vue&type=style&index=0&id=a1b058a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b058a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VCol,VImg,VRow,VTextField})
